import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/sports-618/2025/Index.vue')
const IndexDYS = () => import('../activity/sports-618/2025/IndexDYS.vue')
const IndexGacha = () => import('../activity/sports-618/2025/gacha/Index.vue')
const IndexWarmUp = () => import('../activity/sports-618/2025/warm-up/Index.vue')
const LotteryRewardsGacha = () => import('../activity/sports-618/2025/gacha/LotteryRewards.vue')
const ExchangeRewardsGacha = () => import('../activity/sports-618/2025/gacha/ExchangeRewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/sports-618/2025',
  name: 'activity_sports_618_2025',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'S+会员618年中钜惠',
  },
}

export const indexDYSRoute: RouteConfig = {
  path: '/activity/sports-618/2025-dys',
  name: 'activity_sports_618_2025_dys',
  component: IndexDYS,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'S+会员618年中钜惠',
  },
}

export const indexGachaRoute: RouteConfig = {
  path: '/activity/sports-618/2025-gacha',
  name: 'activity_sports_618_2025_gacha',
  component: IndexGacha,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '惊喜扭蛋得好礼',
  },
}

export const indexWarmUpRoute: RouteConfig = {
  path: '/activity/sports-618/2025-warm-up',
  name: 'activity_sports_618_2025_warm_up',
  component: IndexWarmUp,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'S+会员618年中钜惠',
  },
}

export const lotteryRewardsGachaRoute: RouteConfig = {
  path: '/activity/sports-618/2025-gacha/lottery-rewards',
  name: 'activity_sports_618_2025_gacha_lottery_rewards',
  component: LotteryRewardsGacha,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export const exchangeRewardsGachaRoute: RouteConfig = {
  path: '/activity/sports-618/2025-gacha/exchange-rewards',
  name: 'activity_sports_618_2025_gacha_exchange_rewards',
  component: ExchangeRewardsGacha,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '兑换记录',
  },
}

export default [
  indexRoute,
  indexDYSRoute,
  indexGachaRoute,
  indexWarmUpRoute,
  lotteryRewardsGachaRoute,
  exchangeRewardsGachaRoute,
]
